<template>
<!-- 活动说明 -->
<el-form class="editorClass">
  <el-form-item label="活动推广：" label-width="120px" v-show="sfyyyqdl">
    <el-row>
      <el-col :span="8">
        每份现金金额：<el-input v-model="mfxjje" placeholder="请输入金额" maxlength="20" style="width: 50%;"/> 元
      </el-col>
      <el-col :span="8">
        奖励份数：<el-input v-model="jlfe" placeholder="请输入整数" maxlength="20" style="width: 50%;"/> 份
      </el-col>
      <el-col :span="8">
        需要充值金额： <b style="color: #F56C6C"> {{xyczje.toFixed(2)}} </b> 元
      </el-col>
    </el-row>
    <div class="tishi">
      <p>提示：1. 本红包用于奖励创客推广本活动；</p>
      <p>2. 本功能需要进行现金充值，活动结束后未领取的金额，请到活动列表中的"推广记录"功能页面中申请退款；退款将退回原微信支付账户；</p>
      <p>3. 充值金额含6‰的手续费；活动配置完成后在开启活动时根据提示进行充值操作。 </p>
    </div>
  </el-form-item>
  <el-form-item label="创客分享奖现金：" label-width="120px">
    <el-button type="danger" @click="configuration(2)" v-show="isEdit != 2">配置</el-button>
    <template v-if="recharge.totalcount !=0">
      <span class="threePrice">单份奖励：{{rewardTwo}}元</span>
      <span class="threePrice">奖励份数：{{recharge.totalcount}}份</span>
      <span class="threePrice">需充值金额：{{Math.ceil(recharge.totalprice*100)/100}} 元（微信收取{{wxrate*1000}}‰手续费）</span>
    </template>
    <template v-else>
      <span class="threePrice">无配置</span>
    </template>
    <el-button type="primary" @click="chongzhiPz()" v-show="isEdit != 2 && recharge.totalcount !=0">重置</el-button>
  </el-form-item>
  <!-- 编辑器 -->
  <el-form-item label="活动说明：" label-width="120px">
    <!-- 富文本编辑器组件 -->
    <wjEditor :desc="content1" @change="contentChangeOne"/>
  </el-form-item>
  <div class="dialogFooter">
    <el-button @click="toPrevStep">上一步</el-button>
    <el-button type="danger" @click="saveAllForm"
     v-if="!(isEdit == 2 || isEdit == 3)" :loading="loadingBut">{{loadingButText}}</el-button>
  </div>
  <!-- 创客分享奖现金 -->
  <el-dialog title="创客分享奖现金" :visible.sync="prizeCash" :center="true" width="30%">
    <el-form style="display:flex;">
      <el-form-item label="单份奖励：" style="display:flex;margin-right: 30px;margin-bottom:0;">
        <span>{{rewardTwo}}元</span>
      </el-form-item>
      <el-form-item label="奖励份数：" style="display:flex;margin-bottom:0;">
        <el-input v-model="recharge.totalcount" placeholder="请输入奖励份数" maxlength="7"/>
      </el-form-item>
    </el-form>
    <p>充值金额：<span>　{{Math.ceil(recharge.totalprice*100)/100}} 元（含微信收取{{wxrate*1000}}‰手续费）</span></p>
    <p>分享规则：　<el-checkbox v-model="fxdpyq" disabled>分享到朋友圈</el-checkbox></p>
    <el-form-item label="分享文案：" style="display:flex;margin-bottom:0;">
      <el-input type="textarea" v-model="recharge.remark" :rows="3" placeholder="请输入分享文案内容" maxlength="100" show-word-limit/>
    </el-form-item>
    <el-form-item label="分享要求：" style="margin-bottom: 0;">
      <div class="fxyqClass">
        <p v-for="item in tasktyps.descriptions" :key="item">{{item.sort}}.{{item.taskdesc}};</p>
      </div>
    </el-form-item>
    <b style="display: block;margin-bottom: 10px;">付费推广目的：</b>
    <ul>
      <li style="line-height: 32px;" v-for="(item, index) in ckfxjxj" :key="index">{{item.name}}</li>
      <li style="margin-top: 5px;">4.示例视频</li>
      <ul class="videoandpic">
        <li v-for="(item, index) in tasktyps.examples" :key="index" @click="handleplay(item)">
          <img :src="baseOssUrl+item.videoimg"/>
          <i class="el-icon-video-play mengceng" v-show="item.mediatype == 2"></i>
          <!-- <img :src="item.mediapath"/> -->
        </li>
      </ul>
    </ul>
    <div style="padding-top:10px;text-align:center">
      <el-button @click="prizeCash = false">取 消</el-button>
      <el-button type="danger" @click="handleJxj()">确定</el-button>
    </div>
  </el-dialog>
  <!-- 图片查看 -->
  <el-dialog :visible.sync="largeImage" @closed="clearImg" title='图片查看'>
    <div class="imgDialog">
      <img :src="showImageUrl"/>
    </div>
  </el-dialog>
  <el-dialog :visible.sync="videoVisible"  width="30%" @close="closeDialog">
    <video-player ref="videoPlayer" class="video-player vjs-custom-skin" :playsinline="true" :options="playerOptions" />
  </el-dialog>
</el-form>
</template>
<script>
import wjEditor from '../../components/MyWangEditor';
import { getActivityComplete,getActivityeXplain,configtaskType,configSave, delPeizhi } from "../../api/activityFormList";
export default {
  name: "activityDescription",
  components: { wjEditor },
  data () {
    return {
      baseOssUrl: localStorage.BaseOssUrl,
      editActivityId: "", // 活动id
      isEdit:'',
      content1: '', // 富文本
      mfxjje: '', // 每份现金金额
      jlfe: '', // 奖励份数
      // xyczje: 20, // 需要充值金额
      sfyyyqdl: false, // 是否有预约签到礼
      loadingBut: false,
      loadingButText: '保存',

      rewardTwo: 5, // 单份奖励
      wxrate: 0.006, // 微信手续费
      prizeCash: false, // 创客分享奖现金
      recharge: {},
      tasktyps: {},
      fxdpyq: true, // 分享到朋友圈
      // 付费推广目的
      ckfxjxj: [
        {name: '1.鼓励创客将本活动分享到朋友圈，且在朋友圈至少保留24小时；'},
        {name: '2.创客按照分享要求，进行分享；需按照示例视频进行录制视频后，上传给商家；'},
        {name: '3.商家对分享的有效性进行辨别审核，审核通过后奖励直接发放给创客微信零钱。'},
      ],
      largeImage: false, // 图片查看
      showImageUrl: "",
      videoVisible: false, // 视频弹框
      playerOptions: {
        autoplay: false, // 如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: 'zh-CN',
        aspectRatio: '4:3', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [{
          src: "" // 视频url地址
        }],
        poster: '', // 你的封面地址
        width: document.documentElement.clientWidth, //播放器宽度
        notSupportedMessage: '此视频暂无法播放，请稍后再试', // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true // 全屏按钮
        }
      },
    }
  },
  computed: {
    xyczje() {
      return this.mfxjje * this.jlfe * 1.006;
    },
    // 需充值金额
    // totalprice() {
    //   return this.rewardTwo * this.recharge.totalcount * (1 + this.wxrate);
    // },
  },
  watch: {
    // 需充值金额
    'recharge.totalcount'(newV,oldV) {
      this.recharge.totalprice = this.rewardTwo * this.recharge.totalcount / (1 - this.wxrate);
    }
  },
  methods: {
    // 上一步
    toPrevStep(){
      this.$emit('toPrevStep',2)
    },
    // 活动说明
    contentChangeOne(content) {
      this.content1 = content;
    },
    initComponent(val,type) {
      this.editActivityId = val;
      this.isEdit = type;
      if (type == 0) {
        this.content1 = `<p>1、政策锁定说明 <br>2、差价3倍返还说明 <br>3、活动时间说明 <br>4、退款说明</p>`
        this.mfxjje = ''; // 金额
        this.jlfe = ''; // 份数
        this.xyczje = ''; // 需要充值金额
      }
      // if(type == 1 || type == 2 || type == 3){
      //   this.init();
      // }
      this.init();
      this.getPeizhi(); // 获取配置详情
    },
    // 初始化
    init () {
      let params={
        activityId:this.editActivityId,
      }
      getActivityeXplain(params).then((data) => {
        let newObj = data.ResultObj;
        this.content1 = newObj.ActivityeXplain; // 活动说明
        this.mfxjje = newObj.RewardAmount; // 金额
        this.jlfe = newObj.RewardAmountCount; // 数量
        this.sfyyyqdl = newObj.IsHaveSignUp; // 是否有预约签到礼
      })
    },
    // 保存
    saveAllForm(){
      if(this.content1 == "") {
        this.$swal({
          type: "warning",
          text: "请输入活动说明",
        });
        return false;
      }
      this.loadingBut = true;
      this.loadingButText = '提交中...';
      let addParams = {
        activityId: this.editActivityId, // 活动id
        activityContent: this.content1, // 活动说明富文本
        rewardAmount: this.mfxjje, // 每份现金金额
        rewardAmountCount: this.jlfe, // 奖励份数
      };
      getActivityComplete(addParams).then((data) => {
        if (data.ResultCode == 1) {
          this.$swal({
            type: "success",
            text: "操作成功",
          });
          this.loadingBut = false;
          this.loadingButText = '保存';
          this.$emit('saveAllForm',this.content1);
        }
      });
    },
    // 重置
    chongzhiPz() {
      let dpid = localStorage.getItem("dpid");
      dpid==null?0:dpid
      let params = {
        tasktype: 2, // 类型 1=分享赚钱-店铺充值 2=分享赚钱-活动充值  5=分享赚钱-幸运购
        shopid: dpid?dpid:0, // 店铺ID
        activityid: this.editActivityId, // 活动ID
      };
      delPeizhi(params).then(data => {
        if (data.resultCode == 1) {
          this.$swal({
            type: "success",
            text: "操作成功",
          });
          this.recharge.totalcount = 0;
        }
      });
    },
    // 配置
    configuration() {
      this.prizeCash = true;
      this.getPeizhi(); // 获取配置详情
    },
    getPeizhi() {
      let dpid = localStorage.getItem("dpid");
      dpid==null?0:dpid
      let params={
        shopid: dpid?dpid:0, // 店铺ID
        activityid: this.editActivityId, // 活动ID
      }
      configtaskType(params, 2).then(data => {
        if (data.resultCode == 1) {
          this.tasktyps = data.resultObj.tasktyps[0]; // 任务类型集合
          this.recharge = data.resultObj.recharge; // 配置记录(充值单记录)
          this.rewardTwo = data.resultObj.univalence; // 单价 单位：元
          this.wxrate = data.resultObj.wxrate; // 微信手续费 默认0.006
        }
      })
    },
    // 确定配置
    handleJxj() {
      let dpid = localStorage.getItem("dpid");
      dpid==null?0:dpid
      let StartTime = localStorage.getItem("StartTime").split(' ')[0]
      let EndTime = localStorage.getItem("EndTime").split(' ')[0]
      let params={
        tasktype: 2, // 类型 1=分享赚钱-店铺充值 2=分享赚钱-活动充值  5=分享赚钱-幸运购
        num: Number(this.recharge.totalcount), // 份额
        remark: this.recharge.remark, // 分享文案(备注)
        shopid: dpid?dpid:0, // 店铺ID
        activityid: this.editActivityId, // 活动ID
        operatorid: Number(localStorage.Id), // 操作人id
        begintime: StartTime, // 有效期-开始 格式：yyyy-MM-dd
        endtime: EndTime, // 有效期-结束 格式：yyyy-MM-dd
        bttids: this.fxdpyq==true?'1':[], // 任务类型ID 多个用英文逗号隔开
      }
      configSave(params).then(data => {
        if (data.resultCode == 1) {
          this.$swal({
            text:"配置成功",
            type:"success"
          })
          this.prizeCash = false; // 配置
        }
      })
    },
    // 查看大图
    handleplay(itemI) { // 媒体素材类型 1=图片 2=视频
      if(itemI.mediatype ==1) {
        this.largeImage = true;
        this.showImageUrl = localStorage.BaseOssUrl + itemI.videoimg;
      }
      if(itemI.mediatype ==2) {
        this.palySeevideo(localStorage.BaseOssUrl + itemI.mediapath);
      }
    },
    // 关闭查看大图
    clearImg(){
      this.largeImage = false;
    },
    // 播放视频
    palySeevideo(url){
      this.videoVisible = true;
      this.playerOptions.sources[0].src = url;
    },
    closeDialog() {
      this.$refs.videoPlayer.player.pause();
    },
    
  },
}
</script>
<style scoped>
.editorClass {
  width: 85%;
  margin: 20px auto;
  margin-left: 30px;
}
/* 底部操作区域： 保存/上一步 */
.dialogFooter {
  width: 100%;
  height: 50px;
  text-align: center;
  margin: 30px 0 20px 0;
}
/* 提示 */
.tishi {
  width: 100%;
  margin: 0 auto;
  color: #6699FF;
  line-height: 15px;
}
.tishi>p:nth-child(2) {
  margin-left: 43px;
}
.tishi>p:last-child {
  margin-left: 43px;
}
/* 创客分享奖现金 */
.threePrice {
  font-weight: normal;
  font-size: 13px;
  margin-left: 30px;
}
/* 分享要求 */
.fxyqClass {
  color: #999;
  line-height: 15px;
  float: left;
}
.imgDialog {
  width: 100%;
  height: 500px;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
}
/* 视频 & 图片 集合 */
.videoandpic {
  width: 96%;
  margin: 10px auto;
  padding-left: 0;
  position: relative;
  display: inline-block;
}
.videoandpic>li{
  float: left;
  margin: 0 10px 5px 0;
  cursor: pointer;
}
.videoandpic>li>img {
  width: 100px;
  height: 100px;
  border-radius: 5px;
}
.mengceng {
  position: absolute;
  left: 40px;
  top: 36px;
  font-size: 30px;
  color: #666;
}
</style>


// WEBPACK FOOTER //
// activityDescription.vue?48e2af35